angular.module('App.MyAccount.Ctrl', [
      'jv.Common.Directives.Tooltip',
      'jv.Common.Directives.Breadcrumbs',
      'jv.common.responsive',
      'ngStorage'
])
.filter('newLineI18N', function(){
    return function(text){
        if (text){
            var newText = text.split('\n');
            return newText;
        }else{
            return text;
        }
    };
})
.controller('MyAccountCtrl', ['$scope', '$rootScope', '$window', '$localStorage', function($scope, $rootScope, $window, $localStorage){
    $scope.myAccount = $scope.myAccount || {};
    $scope.companyName = window.companyName;
    $scope.user = window._jvselfUser;
    $scope.i18n_TestDate = new Date();

    $scope.$on('$routeChangeStart', function () {
        $rootScope.breadcrumbsConfig.links = [
                {
                 linkText: i18n['PROFILE'],
                 link: $scope.jvUrls.admin+'/myaccount/profile.html#/'
             }
         ];
    });
    $scope.$on('$routeChangeSuccess', function(event, current, previous) {
        var editTemplateRoute = '/emailTemplates/:id';
        if ((previous && previous.$$route && previous.$$route.originalPath !== editTemplateRoute) && (current && current.$$route && current.$$route.originalPath !== editTemplateRoute)) {
            $localStorage.currentTemplatePage = 0;
        }
    });

    $rootScope.breadcrumbsConfig = {
         backText: i18n['GO_BACK_TO'],
         previousText: i18n['PREVIOUS'],
         menuText: i18n['MENU']
    };

}]);